import config from '../../config';
import { LETTERS_V1_STEP, LETTERS_V2_STEP, LETTERS_V3_STEP } from './upsell-flow-steps';

const URLS = {
    [LETTERS_V1_STEP]: '/upsell/letters/v1',
    [LETTERS_V2_STEP]: '/upsell/letters/v2',
    [LETTERS_V3_STEP]: '/upsell/letters/v3'
};

const FLOWS = {
    v50: {
        steps: () => [
            { id: LETTERS_V1_STEP }
        ]
    },
    v51: {
        steps: () => [
            { id: LETTERS_V2_STEP }
        ]
    },
    v53: {
        steps: ({ hasLettersBonus } = {}) => hasLettersBonus ? [] : [
            { id: LETTERS_V3_STEP }
        ]
    }
};

const thankYouUrl = (subscriptionId, isUpsell) =>
    `${config.platformUrl}/subscription/${subscriptionId}/thank-you?is_upsell=${isUpsell}`;

const stepUrl = (step, subscriptionId) => `${URLS[step.id]}?subscriptionId=${subscriptionId}`;

const getNextUrl = ({ next, subscriptionId }) => {
    if (!subscriptionId) return `${config.platformUrl}/dashboard`;

    return next ? stepUrl(next, subscriptionId) : thankYouUrl(subscriptionId, true);
};

const resolveStep = ({ prelander, id, subscriptionId, conditions = {} }) => {
    const flow = FLOWS[prelander];
    const steps = flow?.steps?.(conditions) ?? [];
    const idx = steps.findIndex(s => s.id === id);
    const next = idx === -1 ? undefined : steps[idx + 1];

    return {
        nextUrl: getNextUrl({ next, subscriptionId })
    };
};

const resolveFirstStepUrl = (prelander, subscriptionId, conditions = {}) => {
    const flow = FLOWS[prelander];
    const [first] = flow?.steps?.(conditions) ?? [];

    if (!first) return thankYouUrl(subscriptionId, false);

    return getNextUrl({ next: first, subscriptionId });
};

export {
    resolveStep,
    resolveFirstStepUrl
};
